import template from './wizard_leave_setup_roles.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class WizardLeaveSetupRoles
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.leave_type_id = ko.observable(null);
		this.access_roles = ko.observableArray();
		this.access_roles_visible_profile = ko.observableArray();
		this.selected_balance_roles = ko.observableArray();
		this.visible_on_profile = ko.observableArray(); 
	}

	close()
	{
		this.dialog.close();
	}
}

class WizardLeaveSetupRolesPage
{
	constructor (bindings)
	{
		this.viewModel = new WizardLeaveSetupRoles(this);
		this.bindings = bindings;
	}

	async init()
	{
		const roles = await Utils.getGrapeListAccessRoles();
		this.viewModel.access_roles(roles);
		this.viewModel.access_roles_visible_profile(roles);

		//apply bindings
		if (this.bindings.leave_type_id)
			this.viewModel.leave_type_id(this.bindings.leave_type_id); 

		if (this.bindings.leave_object.visible_on_profile)
			this.viewModel.visible_on_profile(this.bindings.leave_object.visible_on_profile);
		else
		{
			this.viewModel.visible_on_profile.push('admin');
			this.viewModel.visible_on_profile.push('employee');
		}
		
		if (this.bindings.leave_object.show_available_and_cycle_for_roles)
			this.viewModel.selected_balance_roles(this.bindings.leave_object.show_available_and_cycle_for_roles);
		else
		{
			this.viewModel.selected_balance_roles.push('admin');
			this.viewModel.selected_balance_roles.push('employee');
		}
	}

	async back_wizard(v, e)
	{
		if (this.viewModel.leave_type_id())
		{
			this.close();
			//await Grape.dialog.open('WizardLeaveSetupOverview', {leave_type_id: this.viewModel.leave_type_id()});
			return;
		}

		let data = Object.assign(this.bindings.leave_object, {
			visible_on_profile: this.viewModel.visible_on_profile(),
			show_available_and_cycle_for_roles: this.viewModel.selected_balance_roles()
		});
		
		this.close();
		await Grape.dialog.open('WizardLeaveSetupCycle', this.bindings);
	}

	async next_wizard(v, e)
	{
		let data = Object.assign(this.bindings.leave_object, {
			visible_on_profile: this.viewModel.visible_on_profile(),
			show_available_and_cycle_for_roles: this.viewModel.selected_balance_roles()
		});
		
		await Grape.dialog.open('WizardLeaveSetupHolidays', this.bindings);
	}

	async back_and_save(v, e)
	{
		this.bindings.show_available_and_cycle_for_roles = this.viewModel.selected_balance_roles();
		this.bindings.visible_on_profile = this.viewModel.visible_on_profile();
		this.close();
		
		let res = await Grape.fetches.postJSON('/admin/leave_type/save', this.bindings.leave_object);
		if (res.status === 'OK')
		{
			await Grape.alerts.alert({type: 'success', message: tr('Changes has been saved'), title: tr('Success')});
			this.close();
		}
	}
}

export default {
	name: 'WizardLeaveSetupRoles',
	dialog_class: WizardLeaveSetupRolesPage,
	template: template,
	template_filename: 'translation/dialogs/wizard_leave_setup_roles',
	provider: 'ps'
};
